import React from 'react'

export default function DigitalMarketing() {
  return <>
<div class="page-wrapper sec-mar">
        <article
          id="post-3040"
          class="post-3040 page type-page status-publish hentry"
        >
          <div class="inner-post">
            <div
              data-elementor-type="wp-page"
              data-elementor-id="3040"
              class="elementor elementor-3040"
            >
              {/* </div> */}
            </div>
          </div>
        </article>
      </div>

     
	  <section>
        <div className="container-fluid m-2 mx-0">
          <img src="https://thumbs.dreamstime.com/b/digital-marketing-business-concept-business-concept-businessman-click-digital-marketing-button-virtual-screen-text-typography-125648024.jpg" alt="" className='digital-img ' />
        </div>
      </section>


  {/* main section */}

<div className="container">
  <div className="row text-center">
    <h1><b>Our Digital Marketing Services

</b></h1>
<p>Every business owner requires 100% support of a reliable social media marketing company , which is capable of generating sales, exposure and the opportunity to offer desired success rate. Top notch media works is a leading Digital Marketing company from Maharashtra, which provides the best social media marketing service to ensure increased traffic for your business.


</p>
  </div>
</div>


<section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Facebook Marketing

-</span>
                    <h3  className="text-white">
                    Facebook Marketing

                    </h3>
                    <p class="para mb-0 ">
                    To attract the Facebook audience and grow their number rapidly, we provide an exclusive Facebook page management service.


                    </p>
                  </div>
                </div>
              </div>
    
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                       
                        </div>
                     
                        <img src="https://img.freepik.com/premium-vector/facebook-icons-with-laptop-megaphone-digital-marketing-social-media-concept_112255-1902.jpg?w=2000" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


{/* /target Analysis */}
<section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
         
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                         
                        </div>
                        
                        <img src="https://img.freepik.com/premium-vector/instagram-icons-with-laptop-megaphone-digital-marketing-social-media-concept_112255-1904.jpg" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Instagram Marketing


-</span>
                    <h3  className="text-white">
                    Instagram Marketing



                    </h3>
                    <p class="para mb-0 ">
					Create account for banding and engagement of our customers on Instagram Account with the help of Images,Videos and content.

.</p>
                  </div>
                </div>
              </div>
              
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

{/* POC Creation */}

      <section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-LinkedIn Marketing

-</span>
                    <h3  className="text-white">
                    LinkedIn Marketing

                    </h3>
                    <p class="para mb-0 ">
                    The complete LinkedIn profile is created by the professional writer & managed by the experienced professionals using branding strategy.



                    </p>
                  </div>
                </div>
              </div>
    
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                       
                        </div>
                     
                        <img src="https://www.trendyonlinesolution.in/wp-content/uploads/2018/10/link.jpg" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* /Youtube Marketing
 */}
<section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
         
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInLeft"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11">
                         
                        </div>
                        
                        <img src="https://welcometopalestine.info/wp-content/uploads/2021/10/Youtube-Marketing.jpg" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>

          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-Youtube Marketing



-</span>
                    <h3  className="text-white">
                    Youtube Marketing




                    </h3>
                    <p class="para mb-0 ">
					We implementing the essential YouTube channel building and management tips help you reach out to more fans.

</p>
                  </div>
                </div>
              </div>
              
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  
  {/* twitter marketing */}
      <section
        class="mt-4 elementor-section elementor-top-section elementor-element elementor-element-8ee92bb elementor-section-boxed elementor-section-height-default elementor-section-height-default"
        data-id="8ee92bb"
        data-element_type="section"
        data-settings='{"background_background":"classic"}'
      >
        <div class="elementor-container elementor-column-gap-default">
          <div
            class=" elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-b9a4717"
            data-id="b9a4717"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-cb648cc elementor-widget elementor-widget-spinner_heading"
                data-id="cb648cc"
                data-element_type="widget"
                data-widget_type="spinner_heading.default"
              >
                <div class="elementor-widget-container">
                  <div class="section-title  primary4 position-relative">
                    <span>-LinkedIn Marketing

-</span>
                    <h3  className="text-white">
                    Twitter Marketing

                    </h3>
                    <p class="para mb-0 ">
                    We at Top Notch Media Works help you manage your twitter account by various professionals. Although , you can do it on your own but we are one of the best media works company in Maharashtra, to help lead your business through social media by sharing various online images, videos, creating forum discussions etc. in a creative and in a very unique way to attract various clients for your business or company. So, make Top Notch your choice and get the solutions to achieve success with us.


                    </p>
                  </div>
                </div>
              </div>
    
              <div
                class="elementor-element elementor-element-4ca47ad elementor-widget elementor-widget-spinner_button text-center"
                data-id="4ca47ad"
                data-element_type="widget"
                data-widget_type="spinner_button.default"
              >
                <div class="elementor-widget-container">
                  <div
                    class="about1-content wow fadeInLeft"
                    data-wow-duration="1.5s"
                    data-wow-delay="0.2s"
                  >
                    <a href="tel:9158111116" class="eg-btn btn--primary btn--lg">
                     
                     Contact Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="elementor-column elementor-col-50 elementor-top-column elementor-element elementor-element-1000224"
            data-id="1000224"
            data-element_type="column"
          >
            <div class="elementor-widget-wrap elementor-element-populated">
              <div
                class="elementor-element elementor-element-389eeb3 elementor-widget elementor-widget-spinner_about"
                data-id="389eeb3"
                data-element_type="widget"
                data-widget_type="spinner_about.default"
              >
                <div class="elementor-widget-container">
                  <div class="order-lg-2 order-1">
                    <div
                      class="about-images wow fadeInRight"
                      data-wow-duration="1.5s"
                      data-wow-delay="0.2s"
                    >
                      <div class="row g-0">
                        <div class="col-6 about11 mt-5">
                       
                        </div>
                     
                        <img src="https://media.istockphoto.com/id/1413735503/photo/social-media-social-media-marketing-thailand-social-media-engagement-post-structure.jpg?s=612x612&w=0&k=20&c=7Y4Bdom9c7paYa67nSCvwSuFoppYxJIh-CTYqe6J4Js=" alt="" />
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </section>



    </>
}